var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ia-box-query" },
    [
      !_setup.queryDone
        ? _c(_setup.ChatComponent, {
            attrs: {
              placeholder: _setup.texts.placeholder,
              modelValue: _setup.suggestionText,
              isLoading: _setup.isLoading,
            },
            on: {
              "new-query": _setup.handleQuerySubmit,
              "cancel-query": _setup.handleCancelQuery,
            },
          })
        : _vm._e(),
      !_setup.queryDone
        ? _c(_setup.ChatSuggestionsComponent, {
            on: { "suggestion-selected": _setup.handleSuggestionSelected },
          })
        : _vm._e(),
      _setup.queryDone
        ? _c(_setup.ActualQueryComponent, {
            attrs: { query: _setup.suggestionText },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }